(function () {
  var EXP_ID = '1004203787';
  var VAR_1_ID = '1004478826';
  var CONTROL_ID = '1004478825';
  var TEST_CLASS = 'ACK-058_var_1';
  var DISMISS_KEY = 'ACK-058_dismissed';
  var BASE = 'ACK-058_cart-recovery';

  var SVG = {
    cartIcon:
      '<svg width="19" height="19" viewBox="0 0 20 21" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.03448C0 0.463154 0.463154 0 1.03448 0H3.25791C4.46059 0 5.47642 0.884556 5.64696 2.06897H18.9655C19.2537 2.06897 19.5288 2.18915 19.7245 2.40057C19.9203 2.61199 20.019 2.89549 19.997 3.18279L19.5032 9.60126C19.3512 11.5775 17.7033 13.1034 15.7213 13.1034H6.96133L7.08933 14.1787C7.10998 14.3521 7.25707 14.4828 7.43174 14.4828H16.2069C16.7782 14.4828 17.2414 14.9459 17.2414 15.5172C17.2414 16.0886 16.7782 16.5517 16.2069 16.5517H7.43174C6.20901 16.5517 5.17942 15.6374 5.03487 14.4233L3.60032 2.37303C3.57967 2.19958 3.43259 2.06897 3.25791 2.06897H1.03448C0.463154 2.06897 0 1.60581 0 1.03448ZM6.71502 11.0345H15.7213C16.6222 11.0345 17.3713 10.3409 17.4403 9.44258L17.8484 4.13793H5.894L6.71502 11.0345Z" fill="#00A651"/>' +
      '<path d="M10.3448 19.3103C10.3448 20.0721 9.72729 20.6897 8.96552 20.6897C8.20374 20.6897 7.58621 20.0721 7.58621 19.3103C7.58621 18.5486 8.20374 17.931 8.96552 17.931C9.72729 17.931 10.3448 18.5486 10.3448 19.3103Z" fill="#00A651"/>' +
      '<path d="M17.2414 19.3103C17.2414 20.0721 16.6238 20.6897 15.8621 20.6897C15.1003 20.6897 14.4828 20.0721 14.4828 19.3103C14.4828 18.5486 15.1003 17.931 15.8621 17.931C16.6238 17.931 17.2414 18.5486 17.2414 19.3103Z" fill="#00A651"/>' +
      '</svg>',
    arrow:
      '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5.09194 0.100821L4.92622 0.266524C4.81639 0.376352 4.81639 0.55443 4.92622 0.664282L9.10967 4.84774L0.299816 4.84773C0.144496 4.84773 0.0185659 4.97366 0.0185659 5.12898L0.0185659 5.36336C0.0185659 5.51868 0.144496 5.64461 0.299816 5.64461L9.10967 5.64461L4.92624 9.82806C4.81641 9.93789 4.81641 10.116 4.92624 10.2258L5.09196 10.3915C5.20179 10.5014 5.37987 10.5014 5.4897 10.3915L10.4362 5.44504C10.546 5.33521 10.546 5.15713 10.4362 5.04728L5.48968 0.100821C5.37985 -0.0090305 5.20177 -0.00903051 5.09194 0.100821Z" fill="#00A651" stroke="white" stroke-width="0.0368421"/>' +
      '</svg>',
    close:
      '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M6.08406 5.02344L9.28906 1.81844L9.95 1.1575C10.0475 1.06 10.0475 0.901563 9.95 0.804063L9.24281 0.0968751C9.14531 -0.000624932 8.98687 -0.000624932 8.88937 0.0968751L5.02344 3.96281L1.1575 0.0965625C1.06 -0.000937499 0.901562 -0.000937499 0.804062 0.0965625L0.0965625 0.80375C-0.000937499 0.90125 -0.000937499 1.05969 0.0965625 1.15719L3.96281 5.02344L0.0965625 8.88937C-0.000937499 8.98687 -0.000937499 9.14531 0.0965625 9.24281L0.80375 9.95C0.90125 10.0475 1.05969 10.0475 1.15719 9.95L5.02344 6.08406L8.22844 9.28906L8.88937 9.95C8.98687 10.0475 9.14531 10.0475 9.24281 9.95L9.95 9.24281C10.0475 9.14531 10.0475 8.98687 9.95 8.88937L6.08406 5.02344Z" fill="black" stroke="black" stroke-width="0.046875"/>' +
      '</svg>',
  };

  var isDesktopQuery = window.matchMedia('(min-width: 768px)');

  function isDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function isVariation1() {
    if (window.location.search) {
      var s = window.location.search;
      if (
        s.indexOf('convert_v=' + CONTROL_ID) !== -1 ||
        s.indexOf(CONTROL_ID) !== -1 ||
        s.indexOf('variation=0') !== -1
      ) {
        return false;
      }
      if (
        s.indexOf('convert_v=' + VAR_1_ID) !== -1 ||
        s.indexOf(VAR_1_ID) !== -1 ||
        s.indexOf('variation=1') !== -1
      ) {
        return true;
      }
    }

    if (document.documentElement.classList.contains(TEST_CLASS)) {
      return true;
    }

    try {
      var exp =
        window.convert &&
        window.convert.currentData &&
        window.convert.currentData.experiments;
      if (exp && exp[EXP_ID]) {
        var currentVar = String(exp[EXP_ID].variation_id);
        if (currentVar === VAR_1_ID) return true;
        if (currentVar === CONTROL_ID) return false;
      }
    } catch (e) {}

    return false;
  }

  function formatPrice(cents) {
    if (typeof cents !== 'number' || !isFinite(cents)) return '';
    return 'R' + (cents / 100).toFixed(2);
  }

  function formatItemCount(count) {
    return count + ' item' + (count === 1 ? '' : 's') + ' in your cart';
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function buildBannerMarkup(cart) {
    var desktop = isDesktopQuery.matches;
    var metaText = formatItemCount(cart.item_count) + ' · ' + formatPrice(cart.total_price);

    var html =
      '<div id="' + BASE + '" class="' + BASE + ' ' + (desktop ? BASE + '--desktop' : BASE + '--mobile') + '" role="region" aria-label="Cart reminder">' +
      (desktop ? '<button type="button" class="' + BASE + '__close" aria-label="Dismiss cart reminder">' + SVG.close + '</button>' : '') +
      '  <div class="' + BASE + '__body">' +
      '    <div class="' + BASE + '__copy">' +
      '      <div class="' + BASE + '__icon" aria-hidden="true">' + SVG.cartIcon + '</div>' +
      '      <div>' +
      '        <p class="' + BASE + '__title">Your picks are still saved</p>' +
      '        <p class="' + BASE + '__meta">' + metaText + '</p>' +
      '      </div>' +
      '    </div>' +
      '    <a href="/cart" class="' + BASE + '__cta">' +
      '      <span class="' + BASE + '__cta-text">View Cart</span>' +
      '      ' + SVG.arrow +
      '    </a>' +
      '  </div>' +
      '</div>';

    return html;
  }

  function attachBannerEvents(bannerEl) {
    var closeBtn = bannerEl.querySelector('.' + BASE + '__close');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
      try {
        sessionStorage.setItem(DISMISS_KEY, 'true');
      } catch (e) {}
      bannerEl.remove();
    });
  }

  function insertBanner(cart) {
    var existing = document.getElementById(BASE);
    var desiredMode = isDesktopQuery.matches ? 'desktop' : 'mobile';

    if (existing) {
      var currentMode = existing.classList.contains(BASE + '--desktop') ? 'desktop' : 'mobile';
      if (currentMode === desiredMode) {
        var meta = existing.querySelector('.' + BASE + '__meta');
        if (meta) {
          meta.textContent = formatItemCount(cart.item_count) + ' · ' + formatPrice(cart.total_price);
        }
        return;
      }
      existing.remove();
    }

    var temp = document.createElement('div');
    temp.innerHTML = buildBannerMarkup(cart);
    var bannerEl = temp.firstElementChild;

    if (isDesktopQuery.matches) {
      document.body.appendChild(bannerEl);
    } else {
      var mobileSearch = document.querySelector('.m-header__mobile-search');
      var mobileHeader = document.querySelector('header.m-header__mobile') || document.querySelector('.m-header__mobile');
      var headerWrapper = document.querySelector('.m-header__wrapper') || document.querySelector('m-header');

      if (mobileSearch && mobileSearch.offsetParent !== null && mobileSearch.parentNode) {
        mobileSearch.insertAdjacentElement('afterend', bannerEl);
      } else if (mobileHeader && mobileHeader.parentNode) {
        mobileHeader.insertAdjacentElement('afterend', bannerEl);
      } else if (headerWrapper && headerWrapper.parentNode) {
        headerWrapper.insertAdjacentElement('afterend', bannerEl);
      } else {
        var main = document.getElementById('MainContent');
        if (main) {
          main.insertAdjacentElement('beforebegin', bannerEl);
        } else {
          document.body.insertAdjacentElement('afterbegin', bannerEl);
        }
      }
    }

    attachBannerEvents(bannerEl);
  }

  function syncRail() {
    if (window.location.pathname.indexOf('/cart') === 0) return;

    if (isDismissed()) {
      var existing = document.getElementById(BASE);
      if (existing) existing.remove();
      return;
    }

    if (!isVariation1()) {
      var existingControl = document.getElementById(BASE);
      if (existingControl) existingControl.remove();
      return;
    }

    fetchCart().then(function (cart) {
      if (isDismissed() || !isVariation1()) return;

      if (!cart || !cart.item_count || cart.item_count <= 0) {
        var emptyBanner = document.getElementById(BASE);
        if (emptyBanner) emptyBanner.remove();
        return;
      }

      insertBanner(cart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRail);
  } else {
    syncRail();
  }

  if (isDesktopQuery.addEventListener) {
    isDesktopQuery.addEventListener('change', syncRail);
  } else if (isDesktopQuery.addListener) {
    isDesktopQuery.addListener(syncRail);
  }

  window.addEventListener('init-ack-058', syncRail);

  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, syncRail);
  }
  document.addEventListener('cart:updated', syncRail);
  document.addEventListener('shopify:cart:updated', syncRail);
})();
